import { BaseResponse } from './_base';

export enum BedType {
  airMattress = 'airMattress',
  bunkBed = 'bunkBed',
  couch = 'couch',
  crib = 'crib',
  doubleBed = 'doubleBed',
  floorMattress = 'floorMattress',
  futonBed = 'futonBed',
  hammockBed = 'hammockBed',
  kingBed = 'kingBed',
  queenBed = 'queenBed',
  singleBed = 'singleBed',
  sofaBed = 'sofaBed',
  toddlerBed = 'toddlerBed',
  waterBed = 'waterBed',
}

export enum RoomType {
  ART_STUDIO = 'ART_STUDIO',
  BACKYARD = 'BACKYARD',
  BALCONY = 'BALCONY',
  BEDROOM = 'BEDROOM',
  BOWLING_ALLEY = 'BOWLING_ALLEY',
  CASINO = 'CASINO',
  CHILDRENS_PLAYROOM = 'CHILDRENS_PLAYROOM',
  COURTYARD = 'COURTYARD',
  DARKROOM = 'DARKROOM',
  DINING_ROOM = 'DINING_ROOM',
  EVENT_ROOM = 'EVENT_ROOM',
  EXTERIOR = 'EXTERIOR',
  FRONT_YARD = 'FRONT_YARD',
  FULL_BATHROOM = 'FULL_BATHROOM',
  GAME_ROOM = 'GAME_ROOM',
  GARAGE = 'GARAGE',
  GYM = 'GYM',
  HALF_BATHROOM = 'HALF_BATHROOM',
  HOT_TUB = 'HOT_TUB',
  KITCHEN = 'KITCHEN',
  KITCHENETTE = 'KITCHENETTE',
  LAUNDRY_ROOM = 'LAUNDRY_ROOM',
  LIBRARY = 'LIBRARY',
  LIVING_ROOM = 'LIVING_ROOM',
  MOVIE_THEATER = 'MOVIE_THEATER',
  MUSIC_STUDIO = 'MUSIC_STUDIO',
  OFFICE = 'OFFICE',
  PATIO = 'PATIO',
  PHOTOGRAPHY_STUDIO = 'PHOTOGRAPHY_STUDIO',
  POOL = 'POOL',
  PORCH = 'PORCH',
  ROOFTOP = 'ROOFTOP',
  STUDIO = 'STUDIO',
  SUNROOM = 'SUNROOM',
  TERRACE = 'TERRACE',
  THEME_ROOM = 'THEME_ROOM',
  WINE_CELLAR = 'WINE_CELLAR',
  WOODSHOP = 'WOODSHOP',
  WORKSHOP = 'WORKSHOP',
  WORKSPACE = 'WORKSPACE',
  COMMON_SPACES = 'COMMON_SPACES',
  DECK = 'DECK',
  GARDEN = 'GARDEN',
  JP_ONLY_FLOOR_PLAN = 'JP_ONLY_FLOOR_PLAN',
  ONSEN = 'ONSEN',
}

export interface PropertyRoom {
  uid: string;
  roomNumber: number;
  bedCounts: Partial<Record<BedType, number>>;
  hasPrivateBathroom?: boolean;
  roomType: RoomType;
}

export interface GetPropertyRoomsResponseTO extends BaseResponse {
  rooms: PropertyRoom[];
}

export interface RoomTypeOption {
  roomType: RoomType;
  description: string;
}

export type GetRoomTypeOptionsResponse = RoomTypeOption[];
